import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const ShareDraftLoadingPanel: React.FC = () => {
  return (
    <Box
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        bgcolor: 'background.paper',
      }}
    >
      <CircularProgress
        size={48}
        sx={{ color: 'primary.main', mb: 2, mt: 20 }}
      />
      <Typography sx={{ color: 'text.secondary' }}>
        Loading contacts...
      </Typography>
    </Box>
  );
};
